import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.102 15.004a.843.843 0 0 1-1.23 0 .843.843 0 0 1 0-1.23l1.12-1.149H7.98l1.122 1.148a.843.843 0 0 1 0 1.23.843.843 0 0 1-1.23 0L5.245 12.38a.843.843 0 0 1 0-1.23l2.625-2.626a.843.843 0 0 1 1.23 0 .843.843 0 0 1 0 1.23l-1.12 1.122h8.011l-1.12-1.121a.843.843 0 0 1 0-1.23.843.843 0 0 1 1.23 0l2.625 2.624a.843.843 0 0 1 0 1.23z"
    }, null, -1)
  ]))]))
}
export default { render: render }